//@flow
import React from 'react';
import type { LevelConfiguration } from 'types/product';
import './styles.scss';
type Props = {
  configurations: Array<LevelConfiguration>,
  onClick: () => void,
  // selectedConfiguration: Object,
};
export const ProductConfiguration = (props: Props) => {
  const { configurations, onClick } = props;
  const sectionWidth = `${100 / configurations.length}%`;
  return (
    <div className={'configuration-container'}>
      <div
        className={'configuration-section'}
        style={{ marginLeft: sectionWidth }}
      >
        {configurations.map((value, idx) => (
          <ul key={idx} style={{ width: sectionWidth }}>
            <li>
              <div
                onClick={e => onClick(idx, value)}
                className={value.isSelected ? 'active-config' : 'config-list'}
              />
            </li>
            <span>{value.view_name}</span>
          </ul>
        ))}
      </div>
    </div>
  );
};
